import { GraphQLQuery } from '@aws-amplify/api';
import { billingClient } from '../../billing-api-integration/client';
import { listProviderMappingsQuery } from './queries';
import { createProviderMappingMutation } from './mutations';
import {
    CreateProviderMappingInput,
    ListProviderMappingsResponse,
    ProviderMapping
} from '../types';

export const listProviderMappings = async (filter?: {
    localEntityId?: string;
    billingProviderId?: string;
    entityType?: string;
}) => {
    const response = await billingClient.graphql<GraphQLQuery<ListProviderMappingsResponse>>({
        query: listProviderMappingsQuery,
        variables: { filter }
    });
    return response.data?.listProviderMappings?.items || [];
};

export const fetchProviderMappings = listProviderMappings;

export const createProviderMapping = async (input: CreateProviderMappingInput) => {
    const response = await billingClient.graphql<GraphQLQuery<any>>({
        query: createProviderMappingMutation,
        variables: { input }
    });
    return response.data?.createProviderMapping as ProviderMapping;
};

export const getStripeCustomerIdForCustomer = async (customerId: string): Promise<string | null> => {
    console.log('getStripeCustomerIdForCustomer called with:', customerId);
    const mappings = await listProviderMappings({
        localEntityId: customerId,
        entityType: 'Customer'
    });
    
    console.log('All mappings found:', mappings);
    
    if (mappings && mappings.length > 0) {
        // Check if billingProviderId is 'stripe' (string) or if billingProvider.key is 'stripe'
        const stripeMapping = mappings.find((m: any) => {
            console.log('Checking mapping:', m);
            return m.billingProviderId === 'stripe' || m.billingProvider?.key === 'stripe';
        });
        console.log('Stripe mapping found:', stripeMapping);
        return stripeMapping?.providerEntityId || null;
    }
    
    console.log('No mappings found');
    return null;
};

export const getPayPalCustomerIdForCustomer = async (customerId: string): Promise<string | null> => {
    console.log('getPayPalCustomerIdForCustomer called with:', customerId);
    const mappings = await listProviderMappings({
        localEntityId: customerId,
        entityType: 'Customer'
    });
    
    console.log('All mappings found:', mappings);
    
    if (mappings && mappings.length > 0) {
        const paypalMapping = mappings.find((m: any) => {
            console.log('Checking mapping:', m);
            return m.billingProviderId === 'paypal' || m.billingProvider?.key === 'paypal';
        });
        console.log('PayPal mapping found:', paypalMapping);
        return paypalMapping?.providerEntityId || null;
    }
    
    console.log('No mappings found');
    return null;
};
